import React from 'react';

import { defaultOperators, defaultFormatters, defaultRenderers } from 'components/Grid';

import { ColumnDefinition, ColumnActions } from 'components/Grid/types';

import { FULL_DATETIME_COLUMN_MIN_WIDTH, FULL_DATETIME_FORMAT, ProtectorType } from 'core/constants';

import { formatMoment } from 'utils/formatters/timezone';

import { ActiveStatusOperator } from 'components/Grid/operators/ActiveStatus';

import AuditTemplateActiveColumn from '../AuditTemplateActiveColumn';
import AuditTemplateActionCell from '../AuditTemplateActionCell';

// Column set and widths follow the builder prototype's templates grid.
export const basicAuditTemplatesColumns = [
  {
    field: 'name',
    headerName: 'Template name',
    flex: 1,
    minWidth: 240,
    nativeFilter: 'name',
    protectorType: ProtectorType.ShortText,
  },
  {
    // Hidden: the prototype's grid carries no Creator column. The column selector can bring it back,
    // and a saved Creator filter still leaves as the native param. Unsortable: SubmissionFormsFilter.ordering
    // covers name / updatedAt / status / audience only.
    field: 'creator',
    headerName: 'Creator',
    defaultVisibility: false,
    sortable: false,
    nativeFilter: 'creator',
    renderCell: defaultRenderers.user,
    valueGetter: (value: unknown) => ({ value }),
    valueFormatter: defaultFormatters.user,
    filterOperators: defaultOperators.user(),
  },
  {
    // `updatedAt` is the last version's timestamp, and Publish is the only write that makes one.
    field: 'updatedAt',
    headerName: 'Last published',
    minWidth: FULL_DATETIME_COLUMN_MIN_WIDTH,
    nativeFilter: 'updatedAt',
    protectorType: ProtectorType.DateTime,
    filterOperators: defaultOperators.date_time(),
    valueFormatter: (value: string | null) => formatMoment(value, FULL_DATETIME_FORMAT),
    renderCell: ({ value }: { value: string }) => (
      <span data-testid="audit-templates-last-published">{formatMoment(value, FULL_DATETIME_FORMAT)}</span>
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    nativeFilter: 'active',
    sortable: false,
    filterOperators: ActiveStatusOperator({ active: 'Active', inactive: 'Inactive' }),
    renderCell: ({
      row,
      colDef,
    }: {
      row: { uuid: string; isActive?: boolean; settings?: { isActive: boolean } };
      colDef: { actions: ColumnActions };
    }) => <AuditTemplateActiveColumn row={row} actions={colDef.actions} />,
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: '',
    maxWidth: 50,
    ariaLabel: 'actions_cell',
    sortable: false,
    filterOperators: null,
    renderCell: ({ row }: { row: { uuid: string; name?: string } }) => <AuditTemplateActionCell rowData={row} />,
  },
] as unknown as ColumnDefinition[];
